import { FormErrorSlot } from "./FormErrorSlot";
import { StableSubmitButton } from "./StableSubmitButton";
import { AuthFormFooter } from "./AuthFormFooter";

/** Auth form stack — fixed error slot; optional footer. */
export function AuthFormShell({
    fields,
    error,
    errorTestId = "form-error",
    busy,
    idleLabel,
    busyLabel,
    submitTestId,
    submitDisabled,
    footer,
    footerTestId,
    formTestId,
    onSubmit,
}) {
    return (
        <form onSubmit={onSubmit} className="auth-form" data-testid={formTestId}>
            <div className="auth-form__fields">{fields}</div>
            <FormErrorSlot message={error} testId={errorTestId} />
            <StableSubmitButton
                busy={busy}
                idleLabel={idleLabel}
                busyLabel={busyLabel}
                disabled={submitDisabled}
                testId={submitTestId}
            />
            {footer ? (
                <AuthFormFooter testId={footerTestId}>{footer}</AuthFormFooter>
            ) : null}
        </form>
    );
}
